import { Subscription } from 'rxjs'
import {
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core'
import { ContextService } from '../../services/context.service'

@Component({
  standalone: false,
  selector: 'app-city-selector',
  templateUrl: './city-selector.component.html',
  styleUrls: ['./city-selector.component.scss'],
})
export class CitySelectorComponent implements OnInit, OnDestroy {
  get cities(): any[] {
    return this._cities
  }

  @Input()
  set cities(value: any[]) {
    this._cities = value
    this.filteredCities = value
  }

  @Input()
  showSearch = false

  @Input()
  selected = false

  @HostBinding('class.open')
  opened = false

  private _cities = []

  @Output() onChangeCity = new EventEmitter()

  @Input() ignoreVertical = false

  private subscriptions = new Subscription()
  filterValue = ''
  filteredCities = []

  constructor(private context: ContextService, private elem: ElementRef) {}

  ngOnInit() {
    if (this.ignoreVertical) {
      this.filterValue = ''
    } else {
      this.subscriptions.add(
        this.context.$currentVertical.subscribe(() => {
          if (!this.ignoreVertical) {
            this.filterValue = ''
            this._cities = this.context.vertical.territories.map((city) => ({
              name: city,
              value: city,
            }))
          }
        }),
      )
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe()
  }

  @HostListener('document:click', ['$event'])
  onFocusOut($event) {
    if (!this.elem.nativeElement.contains($event.target)) {
      this.close()
    }
  }

  onChange(item: any) {
    this.filterValue = ''
    if (this.ignoreVertical) {
      this.onChangeCity.emit(item)
    } else {
      this.context.setPoi(null)
      this.context.setCity(item)
    }
    this.close()
  }

  open() {
    this.opened = true
  }

  close() {
    this.opened = false
  }

  toggle() {
    this.opened = !this.opened
  }

  onSearch(value) {
    this.filterValue = value
    this.filteredCities = this._cities.filter((item) => {
      if (!this.filterValue) {
        return true
      }
      const val = item.value || item.name
      return val.toLowerCase().indexOf(this.filterValue.toLowerCase()) !== -1
    })
  }

  isInputShown() {
    return this.showSearch || this.opened
  }

  isSelected(item) {
    return this.context.getContext().city.name === item.name
  }
}
